module.exports = __webpack_public_path__ + "static/media/empty-results.ca1e9601.svg";